<header class="app-header" [ngClass]="{'menu-active': isMenuVisible}">
  <div class="container k-d-flex k-flex-wrap k-align-items-center k-justify-content-between">
    <a routerLink="/" class="app-logo k-d-flex">
      <img src="images/app-logo.webp" alt="Company logo" loading="eager" width="123" height="42">
    </a>
    <div class="header-menu-container k-d-flex k-flex k-flex-wrap k-align-items-center">

      @defer (when isScreenTablet) {
      <nav class="header-menu-panel k-mr-auto k-ml-13">
        <kendo-menu class="header-menu" [items]="menuLinks"></kendo-menu>
      </nav>
      }

      @defer (when isScreenMobile) {
      <form class="single-input-form header-search-form k-d-flex k-ml-auto" #headerSearchForm="ngForm">
        <span class="search-icon k-d-flex k-align-items-center k-justify-content-center k-align-self-center k-ml-3">
          <img src="images/icon/header-search-icon.svg" alt="Search icon" width="20" height="20">
        </span>
        <input type="text" class="form-control" id="headerSearchField" [(ngModel)]="headerSearchField"
          name="Search form" placeholder="Search">
      </form>
      @if (!isUserLoggedIn) {
      <button kendoButton size="small" fillMode="flat" class="k-ml-3">Log in</button>
      <button kendoButton size="small" themeColor="primary" class="k-ml-1">Join now</button>
      } @else {
      <div #profileMenuTarget class="profile-avatar-wrapper k-cursor-pointer k-ml-2">
        <app-avatar></app-avatar>
      </div>
      <kendo-contextmenu [target]="profileMenuTarget" [items]="profileMenuLinks" showOn="click"
        [popupAlign]="{ horizontal: 'left', vertical: 'top' }" [alignToAnchor]="true"></kendo-contextmenu>
      }
      }
    </div>

    <!-- Menu toggle -->
    <button #responsiveMenu (click)="toggleMenu()" kendoButton size="small" fillMode="flat"
      class="header-menu-toggle-btn kendo-icon-btn k-ml-3" aria-label="Toggle menu">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">
        <path
          d="M25 19.4877H3C2.448 19.4877 2 19.0551 2 18.5222C2 17.9892 2.448 17.5566 3 17.5566H25C25.552 17.5566 26 17.9892 26 18.5222C26 19.0551 25.552 19.4877 25 19.4877Z"
          fill="#333F50" />
        <path
          d="M25 12.0853H3C2.448 12.0853 2 11.6528 2 11.1198C2 10.5868 2.448 10.1543 3 10.1543H25C25.552 10.1543 26 10.5868 26 11.1198C26 11.6528 25.552 12.0853 25 12.0853Z"
          fill="#333F50" />
      </svg>
    </button>
  </div>
</header>

<!-- Responsive menu -->
@defer (on interaction(responsiveMenu)) {
<nav class="header-responsive-panel k-d-flex k-flex-column" [ngClass]="{'menu-active': isMenuVisible}">
  <div class="responsive-panel-header k-d-flex k-align-items-center k-justify-content-between k-mb-11">
    <a routerLink="/" class="app-logo k-d-flex">
      <img src="images/app-logo.webp" alt="Company logo" loading="lazy" width="123" height="42">
    </a>
    <button (click)="toggleMenu()" kendoButton size="small" fillMode="flat"
      class="header-menu-toggle-btn kendo-icon-btn k-ml-auto">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
        <path d="M13 1.5L1 13.5M1 1.5L13 13.5" stroke="#0B0B0B" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>

  </div>

  <form class="single-input-form header-search-form k-d-flex k-mb-8" #headerSearchForm="ngForm">
    <span class="search-icon k-d-flex k-align-items-center k-justify-content-center k-align-self-center k-ml-3">
      <img src="images/icon/header-search-icon.svg" alt="Search icon" width="20" height="20">
    </span>
    <input type="text" class="form-control" id="headerSearchField2" [(ngModel)]="headerSearchField" name="Search form"
      placeholder="Search">
  </form>

  <div class="header-responsive-menu k-mb-5">
    <kendo-panelbar>
      <kendo-panelbar-item [ngClass]="{'panelbar-header': menu.items}" *ngFor="let menu of menuLinks"
        [title]="menu.text" [routerLink]="menu.url">
        <kendo-panelbar-item [ngClass]="{'panelbar-header': menuLevel1.items}" *ngFor="let menuLevel1 of menu.items"
          [title]="menuLevel1.text" [routerLink]="menuLevel1.url">
          <kendo-panelbar-item [ngClass]="{'panelbar-header': menuLevel2.items}"
            *ngFor="let menuLevel2 of menuLevel1.items" [title]="menuLevel2.text" [routerLink]="menuLevel2.url">
          </kendo-panelbar-item>
        </kendo-panelbar-item>
      </kendo-panelbar-item>
    </kendo-panelbar>
  </div>

  <div class="responsive-panel-footer k-d-flex k-flex-column k-gap-2 k-mt-auto">
    @if (!isUserLoggedIn) {
    <button kendoButton size="small" themeColor="primary">Join now</button>
    <button kendoButton size="small" fillMode="flat">Log in</button>
    } @else {
    <button kendoButton size="small" fillMode="flat">Log out</button>
    }
  </div>
</nav>
}
